export default __webpack_public_path__ + "static/media/live.8ea96581.svg";